module.exports = __webpack_public_path__ + "media/banner-btn-bg.f1c9c0bc.mp4";